export var CriteriaFieldType;
(function (CriteriaFieldType) {
    CriteriaFieldType["VisualPassToReportOnly"] = "VisualPassToReportOnly";
    CriteriaFieldType["NonVisualPassToReportOnly"] = "NonVisualPassToReportOnly";
    CriteriaFieldType["NonVisualPassToSPOnly"] = "NonVisualPassToSPOnly";
    CriteriaFieldType["NumberType"] = "Number";
    CriteriaFieldType["StringType"] = "Text";
    CriteriaFieldType["DateType"] = "Date";
    CriteriaFieldType["Decimal"] = "Decimal";
    CriteriaFieldType["Dropdown"] = "Dropdown";
    CriteriaFieldType["TimePeriodDropdown"] = "TimePeriodDropdown";
    CriteriaFieldType["CustomDropdownPvRoll"] = "CustomDropdownPvRoll";
    CriteriaFieldType["CustomDropdownRun"] = "CustomDropdownPvRun";
    CriteriaFieldType["Image"] = "Image";
})(CriteriaFieldType || (CriteriaFieldType = {}));
